/* -------------------------------------------------------------------------- */
/*                               FIELD TYPES                                  */
/* -------------------------------------------------------------------------- */

export const FIELD_TYPES = Object.freeze({
  CURRENCY: "currency",
  NUMBER: "number",
  PERCENT: "percent",
  SELECT: "select",
  SWITCH: "switch",
  SLIDER: "slider",
  SECTION: "section",
  ARRAY: "array",
});

/* -------------------------------------------------------------------------- */
/*                                  CHARTS                                    */
/* -------------------------------------------------------------------------- */

export const CHARTS = Object.freeze({
  PIE: "pie",
  BAR: "bar",
  LINE: "line",
  AREA: "area",
});

/* -------------------------------------------------------------------------- */
/*                                  TABLES                                    */
/* -------------------------------------------------------------------------- */

// export const TABLES = Object.freeze({
//     AMORTIZATION: "amortization",
//     MONTHLY_AMORTIZATION: "monthlyAmortization",
// });

/* -------------------------------------------------------------------------- */
/*                                  ACTIONS                                   */
/* -------------------------------------------------------------------------- */

export const ACTIONS = Object.freeze({
  RESET: "reset",
  COPY: "copy",
  SHARE: "share",
  CSV: "csv",
  PDF: "pdf",
  EXCEL: "excel",
});

/* -------------------------------------------------------------------------- */
/*                               RESULT TYPES                                 */
/* -------------------------------------------------------------------------- */

export const RESULT_TYPES = Object.freeze({
  CURRENCY: "currency",
  NUMBER: "number",
  PERCENT: "percent",
  TEXT: "text",
});

/* -------------------------------------------------------------------------- */
/*                               DEFAULT VALUES                               */
/* -------------------------------------------------------------------------- */

export const DEFAULT_CHART_HEIGHT = 350;

export const DEFAULT_ANIMATION_DURATION = 0.25;
